// extracted by css-extract-rspack-plugin
export default {"modal":"htF_8Hp3qwQM7VQx"};